import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue'
import { PreloadScene } from './preload';
import store from './store';
import Default from './components/Default.vue';
import './icons';
import { syncFrameHeight, isDesktop} from "./helpers";
import lang from './filters/lang';
import currency from './filters/currency';
import closable from './directives/closable';
import socket from '@tv/socket';
import Axios from "axios";

Config.isDesktop = isDesktop();

parent.postMessage({ 'require_sizes':true }, '*');

Axios.defaults.headers.common['X-CSRF-TOKEN'] = Config.csrf_token;

moment.locale(Config.language);

Vue.filter('currency', currency);
Vue.filter('lang', lang);
Vue.directive('closable', closable);

let gameStarted = false;
let loadStarted = false;
let scene;

for (const item of ['paytable', 'reels', 'symbols', 'assets', 'settings']) {
    Config[item] = JSON.parse(atob(Config[item]));
}

Config.resolutionX = Config.settings.resolution && Config.settings.resolution.x ? Config.settings.resolution.x : 1366;
Config.resolutionY = Config.settings.resolution && Config.settings.resolution.y ? Config.settings.resolution.y : 768;
Config.resolutionX_portrait = Config.settings.resolution && Config.settings.resolution.x_portrait ? Config.settings.resolution.x_portrait : 910;
Config.resolutionY_portrait = Config.settings.resolution && Config.settings.resolution.y_portrait ? Config.settings.resolution.y_portrait : 1620;

let width = Config.resolutionX;
let height = Config.resolutionY;

if(!Config.isDesktop && Config.windowHeight > Config.windowWidth) {
    width = Config.resolutionX_portrait;
    height = Config.resolutionY_portrait;
}

if (!General.is_iframe()) {
    document.body.classList.add('iframe-no')
}

const config = {
    type: Phaser.CANVAS,
    pixelArt: true,
    roundPixels: false,
    parent: 'slots-canvas',
    width: width,
    height: height,
    transparent: true,
    physics: {
        default: 'arcade'
    },
    scale: {
        mode: Phaser.Scale.WIDTH_CONTROLS_HEIGHT
    },
    fps: {
        target: 30,
    },
};

let neededWidth = Config.windowWidth;
let messageResizeGot = false;
let emergencyLoadTimer = false;

window.addEventListener('message', function(e) {
    if (!isResizeNeeded(e.data.viewportHeight, e.data.viewportWidth)) {
        return;
    }

    if (e.data.viewportWidth) {
        Config.windowWidth = e.data.viewportWidth;
    }
    
    if (e.data.viewportHeight) {
        Config.windowHeight = e.data.viewportHeight;
        
        messageResizeGot = true;
        
        if(Config.windowHeight > Config.windowWidth) { //todo check how to get orientation from scene
            neededWidth = Config.windowHeight * (1 / (Config.resolutionY_portrait / Config.resolutionX_portrait));
        } else {
            neededWidth = Config.windowHeight / (1 / (Config.resolutionX / Config.resolutionY));
        }

        if(window.innerWidth < neededWidth) {
            neededWidth = window.innerWidth;

            if(Config.windowHeight > Config.windowWidth) { //todo check how to get orientation from scene
                Config.windowHeight = neededWidth / (1 / (Config.resolutionY_portrait / Config.resolutionX_portrait));
            } else {
                Config.windowHeight = neededWidth * (1 / (Config.resolutionX / Config.resolutionY));
            }
        }

        if(gameStarted) {
            syncFrameHeight(Config.windowHeight, neededWidth);
        }
    }
});

$(window).on('resize', () => {
    manualHeightSync();
});

if (!Config.full_integration) {
    setTimeout(() => {
        manualHeightSync();
    }, 250)
}

function manualHeightSync() {
    if(General.is_iframe() && !messageResizeGot) {
        return;
    }

    if(!messageResizeGot) {
        Config.windowHeight = window.innerHeight ? window.innerHeight : window.outerHeight;
        Config.windowWidth = window.innerWidth ? window.innerWidth : window.outerWidth;

        neededWidth = Config.windowWidth;
    }

    syncFrameHeight(Config.windowHeight, neededWidth);

    setTimeout(() => {
        if(gameStarted) {
            syncFrameHeight(Config.windowHeight, neededWidth);
            checkImageRendering();
        }
    }, 500);
}

function isResizeNeeded(height, width) {
    var widthChangedBy = Math.abs(width - Config.resizeCheckWindowWidth);
    var heightChangedBy = Math.abs(height - Config.resizeCheckWindowHeight);

    if (Config.resizeCheckCount) {
        Config.resizeCheckCount--;
    }

    if (Config.resizeCheckCount) {
        return true;
    }

    if (height && (heightChangedBy > 10 || !Config.resizeCheckWindowHeight)) {
        Config.resizeCheckWindowHeight = height;
        Config.resizeCheckCount = 5;
        return true;
    }

    if (width && (widthChangedBy > 10 || !Config.resizeCheckWindowWidth)) {
        Config.resizeCheckWindowWidth = width;
        Config.resizeCheckCount = 5;
        return true;
    }

    return false;
}

Vue.use(BootstrapVue);

new Vue({
    el: '#slots-panel-holder',
    store,
    components: { Default },
});

socket.on('socket_token', res => {
    Config.token = res.token;
});

socket.on('transmission', (packet) =>
{
    log.debug('Received transmission', packet);

    if(packet.action == 'reload') {
        store.commit('setAfterMessage', () => location.reload());
        store.commit('setMessage', 'socket_error');
    }

    if(packet.action == 'logout') {
        store.commit('setAfterMessage', () => location.reload());
        store.commit('setMessage', 'please_login');
    }
});

socket.on('lifetimeAmount', res => {
    if (res.currency == Config.currency_code) {
        store.commit('updateLifetimeAmount', res.amount);
    }
});

socket.on('cooldownTimer', res => {
    store.commit('updateCooldownGamingEnd', res.cooldown_gaming_end);
});

socket.on('balance', res => {
    store.commit('setBalance', res.amount)
});

socket.on('datetime', ({ datetime }) => {
    store.commit('updateDatetime', datetime);
});

setInterval(() => store.commit('incrementDatetime'), 1000);

function loadFont(name, url, callback, callbackParam) {
    var newFont = new FontFace(name, `url(${url})`);

    newFont.load().then(function (loaded) {
        document.fonts.add(loaded);
        callback(callbackParam);
    }).catch(function (error) {
        console.log(error);
    });

    if(name === 'Artifakt') {
        emergencyLoadTimer = setTimeout(() => {
            clearTimeout(emergencyLoadTimer);
            callback(callbackParam);
        }, 5000);
    }
}

function docReady(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", () => {
            setTimeout(fn, 1);
        });
    }
}

function awaitSizes(fn) {
    if (messageResizeGot || !General.is_iframe() || Config.replay_id) {
        fn();
    } else {
        const checkInt = setInterval(() => {
            if (messageResizeGot) {
                fn();
                clearInterval(checkInt);
            }
        }, 50);
    }
}

export function startGame(sceneClass) {
    docReady(function() {
        awaitSizes(() => {
            const path = `/sl/v1/games/${Config.game_name.toLowerCase()}/`;

            if(Config.assets.preLoadFonts) {
                const lastFontName = Object.keys(Config.assets.preLoadFonts)[Object.keys(Config.assets.preLoadFonts).length-1];

                for (const [ name, fileName ] of Object.entries(Config.assets.preLoadFonts)) {
                    const isLast = name === lastFontName;
                    loadFont(name, `${path}${fileName}`, isLast ? loadPreloaderFont : function() {}, isLast ? sceneClass : false);
                }
            } else {
                loadPreloaderFont(sceneClass);
            }
        })
    });
}

function loadPreloaderFont(sceneClass) {
    syncFrameHeight(Config.windowHeight, neededWidth);
    loadFont("Artifakt", "/fonts/Artifakt_Element_Regular.ttf", () => {
        
        let prScene = game.scene.getScene('PreloadScene');
        prScene.events.on("ready", function () { 
            setTimeout(() => {
                if(loadStarted) {
                    return;
                }
                loadStarted = true;
                if(emergencyLoadTimer) {
                    clearTimeout(emergencyLoadTimer);
                }
        
                function setRelay() {
                    game.scene.add('GameScene', sceneClass);
        
                    scene = game.scene.getScene('GameScene');
        
                    if (scene.relay) {
                        store.commit('setRelayMethods', scene.relay.methods);
                        game.events.off(Phaser.Core.Events.POST_RENDER, setRelay);
                    }
        
                    checkImageRendering();
        
                    syncFrameHeight(Config.windowHeight, neededWidth);
                    gameStarted = true;
                }
        
                game.events.on(Phaser.Core.Events.POST_RENDER, setRelay);
            }, 500);
        });

        game.scene.start('PreloadScene');
    });
}

const game = new Phaser.Game(config);
game.scene.add('PreloadScene', PreloadScene, false);


function checkImageRendering() {
    const parent = document.getElementById('slots-canvas');
    const element = parent.firstElementChild;
    
    if(element.clientWidth < 1300) {
        element.setAttribute("style", `width: ${element.style.width}; height: ${element.style.height}; image-rendering: unset !important;`);
    } else {
        element.setAttribute("style", `width: ${element.style.width}; height: ${element.style.height}; image-rendering: pixelated;image-rendering: -moz-crisp-edges;image-rendering: crisp-edges;`);
    }
}